import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Modal } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router";

const API_URL = process.env.REACT_APP_API_URL;

function Levelwise() {
  const [levelCounts, setLevelCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate();
  const getAuthToken = () => localStorage.getItem("token");

  const fetchLevelCounts = async () => {
    setLoading(true);
    try {
      const token = getAuthToken();
      const url = `${API_URL}/myteam-list-lavel11-count`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      console.log("API Response:", result);

      if (result.status === "1" && result.levelCounts) {
        const allLevels = [];
        for (let level = 1; level <= 11; level++) {
          const levelData = result.levelCounts.find(
            (item) => item.level === level
          );
          if (levelData) {
            allLevels.push(levelData);
          } else {
            allLevels.push({
              level: level,
              user_count: 0,
            });
          }
        }

        setLevelCounts(allLevels);
        console.log("Processed Levels:", allLevels);
      } else {
        const defaultLevels = [];
        for (let level = 1; level <= 11; level++) {
          defaultLevels.push({
            level: level,
            user_count: 0,
          });
        }
        setLevelCounts(defaultLevels);
      }
    } catch (error) {
      console.error("Error fetching level counts:", error);
      const errorLevels = [];
      for (let level = 1; level <= 11; level++) {
        errorLevels.push({
          level: level,
          user_count: 0,
        });
      }
      setLevelCounts(errorLevels);
    } finally {
      setLoading(false);
    }
  };

  const handleLevelClick = (level) => {
    navigate(`/levelwiselead?level=${level.level}`);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
    setSelectedLevel(null);
  };

  const getTotalUsers = () => {
    return levelCounts.reduce(
      (total, level) => total + (level.user_count || 0),
      0
    );
  };

  useEffect(() => {
    fetchLevelCounts();
  }, []);

  // ═══════════ REUSABLE INLINE STYLES ═══════════
  const gradientBg =
    "linear-gradient(135deg, #1e1b4b 0%, #3b0f6b 50%, #4c1d95 100%)";

  const buttonBaseStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minWidth: "180px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: 700,
    letterSpacing: "0.02em",
    color: "#ffffff",
    background: gradientBg,
    border: "none",
    borderRadius: "10px",
    transition: "all 0.25s ease",
    boxShadow: "0 8px 20px rgba(38, 47, 85, 0.3)",
  };

  return (
    <div className="padding_15">
      <div className="card">
        {/* ═══════════ CARD HEADER ═══════════ */}
        <div className="card-header">
          <div className="d-flex align-items-center justify-content-between">
            <div className="titlepage">
              <h3>My Team Level (1-11)</h3>
            </div>

            {/* Total Users Badge */}
            <button
              style={{
                background: gradientBg,
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "8px 20px",
                fontSize: "16px",
                fontWeight: 700,
                boxShadow: "0 4px 12px rgba(76, 29, 149, 0.35)",
                minWidth: "60px",
                textAlign: "center",
                cursor: "default",
              }}
            >
              {getTotalUsers()}
            </button>
          </div>
        </div>

        {/* ═══════════ CARD BODY ═══════════ */}
        <div className="card-body">
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-3">Loading team levels...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table bordered hover>
                <thead>
                  <tr>
                    <th className="headinglevel">Level</th>
                    <th className="headinglevel">Team Size</th>
                    <th className="headinglevel">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {levelCounts.map((levelData) => {
                    const isEmpty = levelData.user_count === 0;

                    return (
                      <tr key={levelData.level}>
                        <td>
                          <strong className="level_fonts">
                            Level {levelData.level}
                          </strong>
                        </td>
                        <td>
                          <span
                            className={`badge fs-6 ${
                              isEmpty ? "bg-secondary" : "bg-primary"
                            }`}
                          >
                            {levelData.user_count || 0}
                          </span>
                        </td>
                        <td>
                          <Button
                            onClick={() => handleLevelClick(levelData)}
                            disabled={isEmpty}
                            style={{
                              ...buttonBaseStyle,
                              cursor: isEmpty ? "not-allowed" : "pointer",
                              opacity: isEmpty ? 0.55 : 1,
                            }}
                          >
                            <FaEye />
                            {isEmpty ? "No Data" : "View Details"}
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Levelwise;